/* eslint-disable */
import React, { useEffect, useState } from "react";
import * as API from "../../../framework/API/api";
import { ENTITYNAME, LOGEVENT, MODULE, TOAST_TYPES } from "../../../framework/constant/constant";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { utility } from "../../../framework/utility/utilityProvider";
import { useTranslation } from "../../../locale/useTranslation";
import { EditPageHeader } from "../../../components/EditPageHeader";
import BossDialog from "../../../components/BossDialog";
import ToastNotification from "../../../components/ToastNotification";

const L2VChannelMappingEditForm = (props) => {

    const lang = useTranslation();

    const blankDataItem = {
        ...props.item,
        ChannelNumber: props?.item?.copy ? "Copy of " + props?.item?.ChannelNumber : props?.item?.ChannelNumber ?? "",
        Archive: props?.item?.Archive ?? false
    }

    const [dataItem, setDataItem] = useState(blankDataItem);
    const [nodes, setNodes] = useState([]);

    useEffect(() => {
        loadCombo();
    }, []);

    const loadCombo = async () => {
        let nodeRes = await API.getDataLookup(ENTITYNAME.Nodes, { sort: { Name: 1 } });
        setNodes(nodeRes.data);

        if (props?.item?.Node?.CSID) {
            const selectedNode = nodeRes.data.find(item => item.CSID === props.item.Node.CSID);
            if (selectedNode) { setDataItem(prev => ({ ...prev, Node: selectedNode })) }
        }
    }

    const onChange = (e) => {
        if (e.target.name == "Archive") {
            setDataItem({ ...dataItem, Archive: !dataItem.Archive });
        } else {
            setDataItem({ ...dataItem, [e.target.name]: e.target.value });
        }
    }

    const isValid = () => {

        if (dataItem.ChannelNumber == undefined || dataItem.ChannelNumber == "") {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_channel_number_error_message });
            return false;
        }
        return true;
    }

    const handleSubmit = async (e) => {
        if (!isValid()) return;

        const channelNumber = parseInt(dataItem?.ChannelNumber);

        const finalData = {
            _id: dataItem?._id,
            SID: dataItem?.SID,
            ChannelNumber: channelNumber,
            Node: dataItem?.Node && Object.keys(dataItem?.Node).length > 0 ? {
                _id: dataItem?.Node?._id,
                SID: dataItem?.Node?.SID,
                Name: dataItem?.Node?.Name,
                CSID: dataItem?.Node?.CSID
            } : {},
            Archive: dataItem?.Archive ?? false,
            checkDuplicate: true,
            query: ["ChannelNumber", "=", channelNumber]
        };

        let res = await API.saveData(ENTITYNAME.liveToVodChannelMapping, finalData);

        if (res.success) {
            let logData = { event: res.message == "updated" ? LOGEVENT.UPDATE : LOGEVENT.INSERT, module: MODULE.L2V_CHANNEL_MAPPING, data: res.data, message: res.message };
            API.SaveLogs(logData);
            props.cancelEdit();
            props.refresh();
            utility.deleteLocalStorageItem(ENTITYNAME.liveToVodChannelMapping);
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
    };
    return (
        <BossDialog title={props.item.ChannelNumber ?? lang.l2v_channel_mapping_dialog_header} onClose={props.cancelEdit} width={"600px"}>
            <EditPageHeader onSubmit={handleSubmit} onCancel={props.cancelEdit} showTitle={false} />
            <div className="row mt-2">
                <div className="col-12">
                    <div className='row mt-2'>
                        <div className='col-6'>
                            <label>{lang.channel_number_label} *</label>
                            <input
                                name="ChannelNumber"
                                type="number"
                                className="form-control form-control-sm"
                                onChange={onChange}
                                value={dataItem.ChannelNumber}
                            />
                        </div>
                        <div className="col-6">
                            <label>{lang.node_label}</label>
                            <DropDownList
                                style={{ backgroundColor: "white" }}
                                className="form-control form-control-sm"
                                data={nodes}
                                name="Node"
                                textField="Name"
                                dataItemKey="_id"
                                onChange={onChange}
                                value={dataItem.Node}
                            />
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className='col-6'>
                            <input
                                style={{ border: "1px solid grey" }}
                                name={"Archive"}
                                type='checkbox'
                                onChange={onChange}
                            />
                            <label className="ml-2">{lang.archive}</label>
                        </div>
                    </div>
                </div>
            </div>
        </BossDialog>
    )
};

export default L2VChannelMappingEditForm;